import { render, staticRenderFns } from "./DiscussionRecord.vue?vue&type=template&id=7ee756ef&scoped=true&"
import script from "./DiscussionRecord.vue?vue&type=script&lang=js&"
export * from "./DiscussionRecord.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionRecord.vue?vue&type=style&index=0&id=7ee756ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee756ef",
  null
  
)

export default component.exports